import React, {Component} from 'react';
import Svg from "./Svg";
import {translate} from "../Services/translation";

class DocumentLink extends Component {
    constructor(props) {
        super(props);

        this.invoicePlaceholder = '{InvoiceNumber}';
        this.invoiceNameTemplate = translate('order.documents.downloadable.name.template');
        this.baseUrl = '/invoice-pdf-generator/download';
        this.errorTimeout = 0;

        this.state = {
            fetchState: 'idle',
            error: null,
        }
    }

    // Not the nicest solution, but need to verify that the file actually exists on the FTP.
    download(blob) {
        if (blob !== null) {
            /**
             * @type string
             */
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = this.invoiceNameTemplate.replace(this.invoicePlaceholder, this.props.reference);
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    }

    downloadDocument() {
        if (!this.props.downloadEnabled) return;
        let url = `${this.baseUrl}/${this.props.reference}`;

        this.setState({
            fetchState: 'loading',
        })

        fetch(url, {
            credentials: 'include',
            headers: {
                'litium-request-context': JSON.stringify(window.__litium.requestContext),
            },
            method:"POST"
        })
            .then(res => {
                if(res.ok) {
                    return res.blob();
                } else {
                    return res.json();
                }
            })
            .then(blobOrJson => {
                if (blobOrJson instanceof Blob) {
                    this.download(blobOrJson);
                } else {
                    throw new Error(blobOrJson.message);
                }
            })
            .catch(err => this.showError(err))
            .finally(() => {
                this.setState({
                    fetchState: 'idle',
                })
            });
    }

    render() {
        let classes = [];

        if (this.state.error) classes.push('has-error');
        if (!this.props.downloadEnabled) classes.push('download-disabled');

        return (
            <div onClick={() => this.downloadDocument()} className={classes.join(' ')}>
                {this.props.downloadEnabled && <span className="document-link__icon"><Svg icon="download"></Svg></span>}
                <span className="document-link__name">
                    {this.props.invoiceDate !== '' && <span className="document-link__date">
                        <span>{translate('order.document.invoice.date.label')}</span> {this.props.invoiceDate}
                    </span>}

                    {this.props.name}

                    {this.state.error && <div className="document-link__error">
                        {this.state.error}
                    </div>}

                    {this.state.fetchState === 'loading' ? <div className={ `document-link--state-${this.state.fetchState}` }>
                    </div> : null }
                </span>
            </div>
        );
    }

    showError(err) {
        this.setState({
            error: err.message,
        });

        this.errorTimeout = setTimeout(() => this.setState({ error: null }), 6000)
    }
}

export default DocumentLink;